export function getUrl(webview?: boolean) {
  let basedUrl = '/analiz-rynka-nedvizhimosti-b2b/';

  if (Boolean(webview)) {
    basedUrl += '?webview=1';
  }

  return basedUrl;
}
